/**
 * @param {string} gallerySelector
 * @param {string} galleryLinkSelector
 * @param {string} prefix="I"
 */
const initGallery = (gallerySelector, galleryLinkSelector, prefix = "I") => {
  const galleries = document.querySelectorAll(gallerySelector);
  let galleryId = "gallery-" + prefix;
  galleries.forEach((gallery) => {
    const links = gallery.querySelectorAll(galleryLinkSelector);

    links.forEach(link => {
      link.setAttribute("data-fancybox", galleryId);
    });
    galleryId += prefix;
  });
}

initGallery(".gallery", ".gallery-icon a");
initGallery(".wp-block-gallery", ".blocks-gallery-item a", "W");

